import { Close } from "@mui/icons-material";
import { Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import { useIsMobile } from "src/hooks/useIsMobile";
import { desktopSx, mobileSx } from "src/utils/styles/modalStyles";

interface Props {
  title: string;
  text: string | null;
  disclaimer?: string;
  buttonText: string | null;
  open: boolean;
  onClose: (o: boolean) => void;
  handleClick: () => void;
}

const BasicModal = ({
  title,
  text,
  disclaimer,
  buttonText,
  handleClick,
  open,
  onClose,
}: Props) => {
  const isMobile = useIsMobile();

  return (
    <Modal open={open} disableEnforceFocus>
      <Stack sx={isMobile ? mobileSx : desktopSx} gap={2} width={440}>
        <IconButton onClick={(o) => onClose(!o)} sx={{ alignSelf: "end" }}>
          <Close />
        </IconButton>
        <Stack gap={1}>
          <Typography variant="h5" fontWeight={600} textAlign="center">
            {title}
          </Typography>
          <Typography variant="subtitle1" textAlign="center">
            {text}
          </Typography>
          {disclaimer ? (
            <Typography
              variant="subtitle1"
              fontStyle="italic"
              textAlign="center"
            >
              {disclaimer}
            </Typography>
          ) : null}
        </Stack>
        <Button
          onClick={handleClick}
          size="large"
          sx={{ padding: "10px 20px 10px 20px" }}
        >
          {buttonText}
        </Button>
      </Stack>
    </Modal>
  );
};

export default BasicModal;
